import service from './request'; // 导入配置好的axios文件
import qs from 'qs';

// // 获取验证码
// export function getCodeImg() {
//   return service({
//     url: '/captchaImage',
//     headers: {
//       isToken: false,
//     },
//     method: 'get',
//     timeout: 20000,
//   });
// }
// export function publicKey(data) {
//   return service({
//     url: '/getPublicKey',
//     method: 'get',
//   });
// }

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return service({
    url: '/system/dict/data/type/' + dictType,
    method: 'get',
  });
}
// 站点
export function fetchSite(data) {
  return service({
    url: '/pubs/comSite/list',
    method: 'get',
    headers: {
      isToken: false,
    },
    params: data,
  });
}
//bannr图
//
// 模型列表
export function fetchBanner(data) {
  return service({
    url: 'pubs/com/banner/mdlList',
    method: 'get',
    params: data,
    headers: { siteId: data.siteId },
  });
}
// 模型列表
export function fetchModel(data) {
  return service({
    url: '/pubs/cmsModel/getPullList',
    method: 'get',
  });
}

// 栏目
export function fetchCmsColumn(data) {
  return service({
    url: '/pubs/cmsColumn/getTreeListByCloumn',
    method: 'get',
  });
}
// 栏目列表
export function fetchCmsColumnList(data) {
  return service({
    url: '/pubs/cmsColumn/pageList',
    method: 'get',
    params: data,
  });
}

// 内容列表
export function fetchConentList(data) {
  return service({
    url: '/pubs/cmsContent/pageListAll',
    method: 'get',
    params: { startTime: '', endTime: '', ...data },
  });
}
// 详情
export function getObj(id) {
  return service({
    url: `/pubs/cmsContent/getOne/${id}`,
    method: 'get',
  });
}

// 单页详情
export function getPageObj(id) {
  return service({
    url: `/pubs/cmsColumn/getOne/${id}`,
    method: 'get',
  });
}

// 搜索
export function getSearch(data) {
  return service({
    url: '/pubs/cmsContent/searchData',
    method: 'get',
    params: data,
  });
}

// code
export function getCodeImg(data) {
  return service({
    url: '/code',
    method: 'get',
  });
}
// 媒体注册
export function addMediaRegistry(data) {
  return service({
    url: '/pubs/comMediaRegistry/add',
    method: 'post',
    data: data,
  });
}

// 媒体注册表配置
export function getMediaRegistryConfig(data) {
  return service({
    url: '/pubs/comMediaConfig',
    method: 'get',
    headers: { siteId: data.siteId },
    params: data,
  });
}
//上一页下一页
export function getnextOrUp(data) {
  return service({
    url: '/pubs/cmsContent/nextOrUp',
    method: 'post',
    data: data,
  });
}
